var map = {
	"./1Carousel.jpg": "351a",
	"./2Carousel.jpg": "5cd9",
	"./3Carousel.jpg": "4862",
	"./4Carousel.jpg": "a341",
	"./Certifikat1.png": "7775",
	"./Certifikat2.png": "8b13",
	"./Certifikat3.png": "955e",
	"./Certifikat4.png": "cb0c",
	"./Picture2.jpg": "2b7c",
	"./Picture7.png": "3fdd",
	"./Picture8.jpg": "0145",
	"./Picture81.jpg": "b047",
	"./carbide-drill-bit-mobile.jpg": "a4c2",
	"./carbide-drill-bit.jpg": "f0ef",
	"./de.png": "ce65",
	"./financira-eu.jpg": "4ca1",
	"./gb.png": "8f7f",
	"./logo-sads.png": "2cde",
	"./logo.png": "cf05",
	"./si.png": "5f87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";